// Los textos del catálogo vienen en mayúsculas desde la base de datos. Se muestran en
// formato normal, salvo que ya traigan minúsculas (se respetan) o sean siglas conocidas.
const KEEP_UPPER = new Set(["IT", "TI", "FCN", "SIGEV", "SAP", "RRHH", "SST"])
const LOWER_WORDS = new Set(["de", "del", "la", "las", "el", "los", "y", "e", "o", "en", "a", "al", "por", "con", "para", "un", "una"])

export const smartCase = (text = "", { sentence = false } = {}) => {
  if (!text || text !== text.toUpperCase()) return text

  let isFirst = true
  return text
    .split(/(\s+)/)
    .map((word) => {
      if (!word || /^\s+$/.test(word)) return word

      const letters = word.replace(/[^\p{L}]/gu, "")
      const lower = word.toLowerCase()
      const capitalize = isFirst || (!sentence && !LOWER_WORDS.has(letters.toLowerCase()))
      isFirst = false

      if (KEEP_UPPER.has(letters)) return word
      return capitalize ? lower.replace(/\p{L}/u, (char) => char.toUpperCase()) : lower
    })
    .join("")
}
